import {useState} from "react";
import {useLocalStorageState} from "@bounce/shared/hooks";
import {ReachAccountSearchResult, useSearchAccounts} from "../../apis/requests/accounts/searchAccounts";
import {MIN_SEARCH_LENGTH} from "../templates/template-preview/RenderAsUserSection";
import {LAST_PREVIEW_ACCOUNT_KEY} from "../templates/TemplateFormPage";

export const useAccountPicker = (
  selected: ReachAccountSearchResult | null,
  onSelect: (account: ReachAccountSearchResult | null) => void
) => {
  const [searchInput, setSearchInput] = useState("");
  const [submittedQuery, setSubmittedQuery] = useState("");
  const [open, setOpen] = useState(false);
  const {data: results = [], isFetching} = useSearchAccounts(
    {q: submittedQuery},
    {enabled: submittedQuery.length >= MIN_SEARCH_LENGTH}
  );
  const resultsMatchQuery = submittedQuery.length >= MIN_SEARCH_LENGTH && searchInput.trim() === submittedQuery;

  return {
    selected,
    searchInput,
    onSearchInputChange: setSearchInput,
    onSearch: () => {
      const q = searchInput.trim();
      if (q.length < MIN_SEARCH_LENGTH) return;
      setSubmittedQuery(q);
      setOpen(true);
    },
    onSelect: (account: ReachAccountSearchResult | null) => {
      onSelect(account);
      setOpen(false);
      if (account) {
        setSearchInput("");
        setSubmittedQuery("");
      }
    },
    options: resultsMatchQuery ? results : [],
    isSearching: isFetching,
    open,
    onOpenChange: setOpen,
  };
};

export const useRememberedAccount = (initial: ReachAccountSearchResult | null = null) => {
  const [lastAccount, setLastAccount] = useLocalStorageState<ReachAccountSearchResult | null>(
    LAST_PREVIEW_ACCOUNT_KEY,
    null,
    {encrypted: false}
  );
  const [account, setAccountState] = useState<ReachAccountSearchResult | null>(initial ?? lastAccount);
  const setAccount = (next: ReachAccountSearchResult | null) => {
    setAccountState(next);
    if (next) setLastAccount(next);
  };
  return [account, setAccount] as const;
};
